import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { checkEmailVerificationToken } from '../../../../actions/accountActions';
import { closeAllModals } from '../../../../actions/modalActions';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import IAccountReducer from '../../../../interfaces/reducers/accountReducer';
import IUserProfileReducer from '../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../reducers';
import Button from '../../../base/button/button';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../../base/forms/input';
import { A, P } from '../../../base/typography';
import * as StyledModals from '../myShipmentsModals.styles';
import { verifyEmailSecureInitialValues, verifyEmailSecureSchema } from './verifyEmailSecure.schema';

interface Props {
	modal: string;
	modalHeading?: string;
	modalCallback?: string;
	modalQrCodeValue?: string;
	modalLat?: number;
	modalLng?: number;
	shipmentId?: string;
	page?: number;
	index?: number;
	flag?: boolean;
	email?: string;
}

const VerifyEmailSecure: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { userProfile } = userProfileReducer;
	const accountReducer: IAccountReducer = useSelector<IStore, IAccountReducer>(store => store.accountReducer);
	const { modalSubmitPending, modalSubmitError, modalSubmitErrorDetails } = accountReducer;
	const { modalHeading } = useSelector(({ modalReducer }) => modalReducer);

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{t('page-settings.verifyEmail')}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>

			{modalSubmitError && (
				<StyledModals.ErrorMessage>
					<FaExclamationCircle />
					<div>{modalSubmitErrorDetails !== '' ? modalSubmitErrorDetails : t('genericError')}</div>
				</StyledModals.ErrorMessage>
			)}

			<P>
				{t('page-settings.verifyEmailSecureMessage2')}
				<b>{modalHeading}</b>
				{t('page-settings.verifyEmailSecureMessage3')}
			</P>
			<Formik
				initialValues={verifyEmailSecureInitialValues}
				validationSchema={verifyEmailSecureSchema}
				onSubmit={values => {
					dispatch(
						checkEmailVerificationToken(userProfileReducer.addEmailVerificationId, values.code, userProfile)
					);
				}}>
				<Form>
					<FormikFieldWrapper
						label={t('page-settings.verificationCode')}
						name="code"
						languageComponent="myShipments"
						smallLabel>
						<StyledFormikField type="text" id="code" name="code" placeholder={t('page-settings.code')} />
					</FormikFieldWrapper>

					<Button primary type="submit" isLoading={modalSubmitPending}>
						{t('page-settings.verify')}
					</Button>
				</Form>
			</Formik>
		</StyledModals.Wrapper>
	);
};

export default VerifyEmailSecure;
